import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import tools from './utils/tools'
import animate from 'animate.css'
import VueLazyload from "vue-lazyload";
import loading from "@/components/loading"
import mobileLoading from "@/views/mobile/components/loading"
import showToast from '@/views/mobile/components/message/index.js'
import countTo from 'vue-count-to';
import wow from 'wowjs'
import 'wowjs/css/libs/animate.css';
import 'animate.css';
// viewTop = (this.config.scrollContainer && this.config.scrollContainer.scrollTop) || window.pageYOffset||document.body.scrollTop||document.documentElement.scrollTop;

// 1. 引入你需要的组件
import { Button,Form,Field,Popup,Area,Picker,Overlay } from 'vant'
// 2. 引入组件样式
import 'vant/lib/index.css';
Vue.use(Button);
Vue.use(Form);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Picker);
Vue.use(Overlay);

Vue.use(showToast);
Vue.use(VueLazyload,{
  preLoad: 1.3,
  loading: require('../src/assets/image/loading.gif'),
  attempt: 1
})
Vue.component('loading',loading)
Vue.component('mobileLoading',mobileLoading)
Vue.component('countTo',countTo)

Vue.use(animate)
Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue(); // event Bus 用于无关系组件间的通信。
Vue.prototype.$tools = tools;
Vue.prototype.$wow = wow

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

